import { Formik } from "formik";
import { FC, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { searchName } from "web/constants/toolbar";
import urls from "web/constants/urls";

import { closeNavigation } from "web/features/app/appSlice";

import Search from "./search";

interface ISearchAutocompleteContainerProps {
  className: string;
  onClick?: () => void;
  variant?: "default" | "header";
}

const SearchAutocompleteContainer: FC<ISearchAutocompleteContainerProps> = ({
  className = "",
  onClick = null,
  variant = "default",
}) => {
  const dispatch = useDispatch();

  const { push } = useHistory();
  const { pathname, search } = useLocation();
  const initialValues = useMemo(() => {
    const params = new URLSearchParams(search);
    const paramsSearch = params.get(searchName);
    const paramsSearchDecoded = paramsSearch
      ? decodeURIComponent(paramsSearch)
      : "";

    const searchPhrase =
      pathname === urls.search && paramsSearchDecoded
        ? paramsSearchDecoded
        : "";

    return {
      [searchName]: searchPhrase,
      hasMultisport: false,
      shouldRedirectToMultisport: false,
    };
  }, [pathname, search]);
  const submitHandler = useCallback(
    (values: { search: string; shouldRedirectToMultisport?: boolean }) => {
      const searchPhrase = values[searchName];

      if (values.shouldRedirectToMultisport) {
        push(urls.multisport);
      } else {
        const searchPhraseEncoded = encodeURIComponent(searchPhrase);
        push(`${urls.search}?${searchName}=${searchPhraseEncoded}`);
      }

      dispatch(closeNavigation());
      if (typeof onClick === "function") {
        onClick();
      }
    },
    [dispatch, push, onClick]
  );

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      enableReinitialize
    >
      <Search
        name={searchName}
        className={className}
        pathname={pathname}
        search={search}
        onClick={onClick as () => void}
        variant={variant}
      />
    </Formik>
  );
};

export default SearchAutocompleteContainer;
